<template>
    <div>
           <!-- background-color="#1d1f25"
            text-color="#e3dcdc" -->
        <el-col>
            <el-menu
            :unique-opened='true'
            :router="true"
            class="el-menu-vertical-demo"
         
            :default-active="logUrl"
            :collapse="isCollapse"
            :collapse-transition = "false"
            >
                <common-menu :getMenu="getMenu" :isCollapse="isCollapse"></common-menu>
            </el-menu>
        </el-col>
    </div>
</template>
<script>
import CommonMenu from './menu'
import { mapState, mapMutations,mapActions } from "vuex";
export default {
    name:'sidelist',
    props:{
        isCollapse:Boolean,
    },
    data(){
        return{
            getMenu:[],
            currentMenu:'/home',
        }
    },
    components: {
        CommonMenu
    },
    computed:{
        routeList(){
            return this.$store.state.routeList;
        },
        logUrl(){
            return this.$store.state.logUrl;
        }
    },
    methods:{
        ...mapActions([  
            'saveMenu','saveLogUrl'
        ]),
        //获取菜单
        findTreeDatas:function(){
            this.$api.get(this.API.IgwIam + 'menu/onLoadSysMenu',{},res=>{
                this.getMenu = res.data; 
                this.saveMenu(this.getMenu);
            })
        },
    },
    created(){
        this.saveMenu(this.getMenu);
        this.findTreeDatas();
    },
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    min-height: 400px;
    border-right: none;
}
/* 菜单透明，继承侧栏卡片底色 */
.el-menu { background-color: transparent !important; }

/* 菜单项：圆角胶囊 + 两侧留白 */
.el-menu-item,
.el-submenu__title {
    color: var(--crm-text-2) !important;
    border-radius: 8px;
    margin: 2px 8px !important;
    transition: background .15s, color .15s;
}
.el-menu-item:hover,
.el-submenu__title:hover {
    background: var(--crm-hover) !important;
    color: var(--crm-text) !important;
}
/* 激活态：主色文字 + 浅底 + 左侧指示条 */
.el-menu-item.is-active {
    color: var(--primary-color) !important;
    background: var(--crm-primary-soft) !important;
    font-weight: 600 !important;
    position: relative;
}
.el-menu-item.is-active::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 18px;
    border-radius: 0 3px 3px 0;
    background: var(--primary-color);
}
</style>




// WEBPACK FOOTER //
// src/components/SideList.vue